/** Μεγάλο διακοσμητικό δέντρο (μόνο υπολογιστές) — μπαίνει σε δικό του κενό χώρο στο footer. */
export function ChristmasTree({ className = "" }: { className?: string }) {
  const bulbs = [
    [100, 70, "var(--xmas-bulb-a, #e53935)"], [82, 105, "var(--xmas-bulb-b, #fdd835)"],
    [122, 120, "var(--xmas-bulb-c, #42a5f5)"], [70, 150, "var(--xmas-bulb-d, #ab47bc)"],
    [108, 160, "var(--xmas-bulb-a, #e53935)"], [140, 175, "var(--xmas-bulb-b, #fdd835)"],
    [58, 200, "var(--xmas-bulb-c, #42a5f5)"], [95, 210, "var(--xmas-bulb-d, #ab47bc)"],
    [132, 220, "var(--xmas-bulb-a, #e53935)"], [160, 235, "var(--xmas-bulb-c, #42a5f5)"],
    [45, 245, "var(--xmas-bulb-b, #fdd835)"], [80, 255, "var(--xmas-bulb-a, #e53935)"],
    [118, 262, "var(--xmas-bulb-b, #fdd835)"],
  ] as const;
  return (
    <svg viewBox="0 0 200 320" aria-hidden="true" className={`xmas-tree ${className}`}>
      <rect x="88" y="270" width="24" height="34" rx="3" fill="#7a4a24" />
      <polygon points="100,30 150,120 50,120" fill="#1f7a3a" />
      <polygon points="100,70 168,190 32,190" fill="#1b6b33" />
      <polygon points="100,120 188,275 12,275" fill="#175c2c" />
      <path d="M62 112 Q100 135 140 108 M44 182 Q100 212 158 176 M26 262 Q100 296 176 256"
        stroke="#f5d06b" strokeWidth="3" fill="none" strokeLinecap="round" />
      {bulbs.map(([x, y, c], i) => (
        <circle key={i} cx={x} cy={y} r="6" fill={c} className="xmas-tree-bulb"
          style={{ animationDelay: `${(i % 4) * 0.4}s` }} />
      ))}
      <polygon fill="#fdd835" stroke="#f9a825" strokeWidth="2"
        points="100,4 107,22 126,22 111,33 117,51 100,40 83,51 89,33 74,22 93,22" />
      <rect x="40" y="290" width="34" height="26" rx="3" fill="#c62828" />
      <rect x="54" y="290" width="6" height="26" fill="#fdd835" />
      <rect x="128" y="294" width="30" height="22" rx="3" fill="#1565c0" />
      <rect x="140" y="294" width="6" height="22" fill="#fff" />
    </svg>
  );
}
